import qs from 'qs';
import { useQuery } from 'react-query';

import { axios } from 'lib';

const getSupplierFilesCount = (dpsID, dcID) => {
  return axios.get(
    `/api/dps/${dpsID}/suppliers/${dcID}/files/count`
  );
};

export const useGetSupplierFilesCount = (dpsID, dcID, options = {}) => {
  return useQuery(
    `dps-supplier-${dcID}-count`,
    () => getSupplierFilesCount(dpsID, dcID),
    {
      //@ts-ignore
      initialData: { data: { count: 0 } },
      select: ({ data }) => data,
      ...options,
    }
  );
}
